<template>
  <div :class="$style['form-validation']">
    <div
      v-if="validation && validation.$dirty && validation?.$invalid"
      :class="[
        $style['validation']
      ]">
      <div
        v-if="validation.checked?.$invalid"
        data-test-id="validation-item">
        {{ $t('general/validation-must-be-checked') }}
      </div>
      <div
        v-if="validation.isValidName?.$invalid"
        data-test-id="validation-item">
        {{ $t('general/validation-must-be-a-full-name') }}
      </div>

      <div
        v-if="validation.required?.$invalid"
        data-test-id="validation-item">
        {{ $t('general/validation-cant-be-empty') }}
      </div>
      <div
        v-if="validation.numeric?.$invalid"
        data-test-id="validation-item">
        {{ $t('general/validation-must-only-contain-numbers') }}
      </div>
      <div
        v-if="
          validation.isValidPhone?.$invalid
        "
        data-test-id="validation-item">
        {{ $t('general/validation-must-be-a-phone') }}
      </div>

      <div
        v-if="validation.email?.$invalid"
        data-test-id="validation-item">
        {{ $t('general/validation-must-be-email') }}
      </div>
      <div
        v-if="validation.isValidZipcode && validation.isValidZipcode?.$invalid
        "
        data-test-id="validation-item">
        {{ $t('general/validation-must-be-valid-postal-code') }}
      </div>
      <div
        v-if="validation.minLength?.$invalid"
        data-test-id="validation-item">
        {{
          $t('general/validation-must-be-min-num-characters', {
            num: validation.minLength.$params.min
          })
        }}
      </div>
      <div
        v-if="validation.sameAsPassword?.$invalid"
        data-test-id="validation-item">
        {{ $t('general/validation-passwords-dont-match') }}
      </div>
      <div
        v-if="validation.selected?.$invalid"
        data-test-id="validation-item">
        {{ $t('general/validation-select-a-gender') }}
      </div>
      <div
        v-if="validation.isBirthday?.$invalid"
        data-test-id="validation-item">
        {{ $t('general/validation-must-be-birthday') }}
      </div>
    </div>
    <div
      v-if="customValidation"
      :class="$style['validation']">
      <div
        v-if="customValidation['digit19']"
        data-test-id="validation-item">
        {{
          $t('general/validation-must-be-exactly-num-characters', { num: 19 })
        }}
      </div>
      <div
        v-if="customValidation.digit6"
        data-test-id="validation-item">
        {{
          $t('general/validation-must-be-exactly-num-characters', { num: 6 })
        }}
      </div>
      <div
        v-if="customValidation.before18"
        data-test-id="validation-item">
        {{ $t('general/validation-older-then-18') }}
      </div>
      <div
        v-if="customValidation.after120"
        data-test-id="validation-item">
        {{ $t('general/validation-jounger-then-120') }}
      </div>
      <div
        v-if="customValidation.birthday"
        data-test-id="validation-item">
        {{ $('general/validation-must-be-birthday') }}
      </div>
    </div>
  </div>
</template>
<script setup>
defineProps({
  validation: {
    type: [Object, Boolean],
    required: false,
    default: null
  },
  customValidation: {
    type: [Object, Boolean],
    required: false,
    default: null
  }
})
</script>

<style lang="scss" module>
.validation {
  color: $red;
  font-size: $font-size-xs;
}

.validation-enter-from,
.validation-leave-to {
  transition: all 1s $transition-ease-in;
  transform: translateY(-50%);
  opacity: 0;
}

.validation-enter-to,
.validation-leave-from {
  transition: all 1s $transition-ease-out;
  transform: translateX(0);
  opacity: 1;
}
</style>
